import React from 'react'
import vegas106 from "../images/vegas106_room.jpg";
import vegas106room from "../images/vegas106_family_room.jpg";
import bathroom from "../images/Family_room_bath.jpg";

function Vegasslider() {
  return (
    <div>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={vegas106} className="d-block w-100" alt="family_room Berhampore"/>
    </div>
    <div className="carousel-item">
      <img src={vegas106room} className="d-block w-100" alt="Family Room Berhampore"/>
    </div>
    <div className="carousel-item">
      <img src={bathroom} className="d-block w-100" alt="family luxury room berhampore"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Vegasslider